/**
 * Trigger a UI update in AngularJS by using $timeout.
 * This function can be used anywhere because it uses the global $injector instance to get $timeout.
 */
const updateAngularUi = () => {
    if (typeof window !== 'undefined' && window.$injector) {
        const $timeout = window.$injector.get('$timeout');
        $timeout(() => {});
    }
};

module.exports = {
    updateAngularUi,
};
